import { RemoteGetPortalContatosClientes } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { PortalContatoClientes } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeGetPortalContatosClientes = (): PortalContatoClientes => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<PortalContatoClientes.Result>()

  return new RemoteGetPortalContatosClientes(url, httpClient)
}
